import React from "react";
import {
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState
} from "react-accessible-accordion";
import TeaserVenueContent from "@default/teasers/venue/components/teaser-venue-content";
import TeaserVenueImage from "@default/teasers/venue/components/teaser-venue-image";

const TeaserVenueStructureStandard = ({ item }) => {

  return (
    <AccordionItem uuid={item.id}>
      <AccordionItemHeading>
        <AccordionItemButton>
          <div className="name-wrapper infos">
            {item.label && <h2 className="name">{item.label}</h2>}
          </div>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel>
        <AccordionItemState>
          {({ expanded }) => (
            <div
              className="inner-wrapper content-wrapper"
            >
              <TeaserVenueContent
                expanded={expanded}
                item={item}
              />
            </div>
          )}
        </AccordionItemState>
      </AccordionItemPanel>
    </AccordionItem>
  );
}

export default TeaserVenueStructureStandard;